
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import router from '@/router';
import { StorageServices } from '@/services/StorageServices';
import { BaseUserClient, VillageConfigClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class selectVillageModal extends Vue {

    @Prop() doneCallback: () => void;
    @Prop() cancelCallback: () => void;

    villages: OM.VillageConfig[] = [];
    selectedVillage: OM.VillageConfig = null;

    created(){
        this.selectedVillage = store.state.villageConfig;
        VillageConfigClient.getAvailable()
        .then(x => {
            this.villages = x;
        })
    }

    save(){
        if(store.state.loginData){
            BaseUserClient.setSelectedVillage(store.state.loginData.userIdentifier, this.selectedVillage)
        }

        store.state.villageConfig = this.selectedVillage;
        StorageServices.setVillageConfig(store.state.villageConfig);

        this.$emit('close');

        this.doneCallback();
    }

    cancel(){
        this.cancelCallback();
    }

}
